<template>
  <div class="confirmation">
    <div class="gradient-panel">
      <div class="content-area">
        <div class="callout">
          <h4 class="success-title">
            <i class="material-icons check-circle">check_circle</i> {{ strings.paymentSuccessful }}
          </h4>
          <div class="divider"></div>
          <div class="success-body">
            {{ strings.amount }} <span class="semibold" id="paymentAmount">{{ paymentResource.paymentDetails.amount | currency }}</span>
            {{ strings.submitted }} <span class="semibold" id="policyNumber">{{ paymentResource.policyNumber }}</span>.
            {{ strings.transactionNumber }} <span class="semibold">{{ paymentResource.gateway.transactionId }}</span>.
            {{ strings.delay }}
          </div>
        </div>
        <div v-if="insuranceIsSfi" class="grid-x sfi-insurance">
          <div class="cell small-12 medium-8">
            <h3>{{ strings.sfiCobrand.title }}</h3>
            <div>
              <ul>
                <li v-for="listItem, name, index in strings.sfiCobrand.details" :key="index">
                  {{ listItem }}
                </li>
              </ul>
            </div>
            <button @click="signUpBtn"
              class="button primary-orange expanded-for-small-only sfi-sign-up-btn">
              {{ strings.sfiCobrand.signUpText }}
            </button>
          </div>
          <div class="cell hide-for-small-only medium-4">
            <img src="@/assets/flamingos-rule.svg">
          </div>  
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Utils
import { mapGetters, mapState } from 'vuex';
// Strings
import strings from '../i18n/en/strings.js';

// Constants
import constants from '@/i18n/en/constants';

// Services
import AnalyticsService from '@/services/AnalyticsService';

export default {
  name: 'Confirmation',
  computed: {
    ...mapState(['insuranceType']),
    ...mapGetters({
      insuranceIsSfi: 'GET_IS_INSURANCE_SFI'
    })
  },
  created() {
    let transactionId = this.paymentResource.gateway.transactionId;
    if (transactionId === '' || transactionId === undefined) {
      this.redirectToPage('find-your-bill');
    }
    window.scrollTo(0, 0);
  },
  data() {
    return {
      analyticsConstants: constants.analyticsConstants,
      strings: strings.confirmation,
      paymentResource: this.$store.state.paymentResource
    }
  },
  mounted() {
    AnalyticsService.trackPageView(this.analyticsConstants.PAYMENT_SUCESSFUL);
  },
  methods: {
    signUpBtn() {
      if (this.$store.state.insuranceType.key === 'sfi') {
        window.open(this.strings.sfiCobrand.signUpUrl, '_blank');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';

.confirmation {
  .gradient-panel {
    // Gradient bar needs to be shown on top and bottom of confirmation page
    border-image-slice: 1 1 1;

    .content-area {
      margin-top: 45px;
      margin-bottom: 40px;

      .sfi-insurance {
        margin-top: 18px;

        .sfi-sign-up-btn {
          margin-top: 20px;
        }
      } 

      .callout {
        border: 2px solid $success-color;

        .success-title {
          color: $success-color;
          text-align: center;
          font-weight: normal;

          .check-circle {
            transform: translateY(15%);
          }
        }

        .divider {
          width: 100%;
          height: 1px;
          background-color: $medium-gray;
          margin: 20px 0;
        }

        .success-body {
          font-weight: normal;

          .semibold {
            font-weight: $global-weight-semibold;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Confirmation.vue